export const systemConstants = {
    SYSTEM_EDIT: "system_edit",
    SYSTEM_CREATE: "system_create",
}